import React, { useContext } from 'react';
import CodeableContextProvider from 'codeable/CodeableContextProvider';
import CodeOperationsProvider from 'codeable/CodeOperationsProvider';
import CodeableWrapper from 'codeable/CodeableWrapper';
import CodeableContext from 'contexts/CodeableContext';
import CodeOperationsContext from 'contexts/CodeOperationsContext';

/**
 * Inner component that reads from the per-side contexts to pass to CodeableWrapper.
 * Needed because CodeableWrapper needs values from the context that wraps it.
 */
const EditableSideInner = ({ transcriptID, hasEditPermission, displayContents, children }) => {
  const { onDeselect, onSelectText } = useContext(CodeableContext) || {};
  const { onExcerptSelected } = useContext(CodeOperationsContext) || {};

  return (
    <CodeableWrapper
      isPrint={false}
      hasEditPermission={hasEditPermission}
      onSelectExcerpt={onExcerptSelected}
      onDeselect={onDeselect}
      onSelectText={onSelectText}
      codeableType="Transcript"
      codeableId={transcriptID}
      style={displayContents ? { display: 'contents' } : undefined}
      enableClickFallback
    >
      {children}
    </CodeableWrapper>
  );
};

/**
 * Wraps content with CodeableContextProvider + CodeOperationsProvider + CodeableWrapper
 * for independent selection state per side in comparison view.
 */
const EditableSideWrapper = ({ projectId, transcriptID, hasEditPermission, displayContents, codingUserId, children }) => {
  return (
    <CodeableContextProvider projectId={projectId}>
      <CodeOperationsProvider projectId={projectId} codingUserId={codingUserId}>
        <EditableSideInner transcriptID={transcriptID} hasEditPermission={hasEditPermission} displayContents={displayContents}>
          {children}
        </EditableSideInner>
      </CodeOperationsProvider>
    </CodeableContextProvider>
  );
};

export default EditableSideWrapper;
